"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfirmRegistrationRequestModel = function ConfirmRegistrationRequestModel(props) {
    (0, _classCallCheck3.default)(this, ConfirmRegistrationRequestModel);

    this.shopId = props.shopId;
    this.password = props.password;
    // Бакэнд-и просят, чтобы не отправляли email eсли кода нет
    this.email = props.email_code ? props.email : undefined;
    this.ul_name = props.ul_name;
    this.username = props.username;
    // Бакэнд-и просят, чтобы не отправляли phone eсли кода нет
    this.phone = props.sms_code ? props.phone : undefined;
    this.inn = props.inn;
    this.sms_code = props.sms_code ? props.sms_code : undefined;
    this.email_code = props.email_code ? props.email_code : undefined;
};

exports.default = ConfirmRegistrationRequestModel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/Models/lib/ConfirmRegistrationRequest.js
// module id = 1586
// module chunks = 0